exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d2-crud .d2-crud-header[data-v-4570b7aa]{border-bottom:1px dotted rgba(0,0,0,.2)}.d2-crud .d2-crud-body[data-v-4570b7aa]{padding:15px 0;overflow:hidden}.d2-crud .d2-crud-pagination[data-v-4570b7aa]{padding:15px 0}", ""]);

// exports
